import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function formatDayOfWeek(dayOfWeek) {
  switch (dayOfWeek) {
    case 'MONDAY':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-features.delay.days-of-week.MONDAY"
      });
    case 'TUESDAY':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-features.delay.days-of-week.TUESDAY"
      });
    case 'WEDNESDAY':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-features.delay.days-of-week.WEDNESDAY"
      });
    case 'THURSDAY':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-features.delay.days-of-week.THURSDAY"
      });
    case 'FRIDAY':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-features.delay.days-of-week.FRIDAY"
      });
    case 'SATURDAY':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-features.delay.days-of-week.SATURDAY"
      });
    case 'SUNDAY':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-features.delay.days-of-week.SUNDAY"
      });
    case 'EVERY_DAY':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-features.delay.days-of-week.EVERY_DAY"
      });
    case 'WEEKDAY':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-features.delay.days-of-week.WEEKDAY"
      });
    case 'WEEKEND':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-features.delay.days-of-week.WEEKEND"
      });
    default:
      return null;
  }
}